import { Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  // The filter shares a fixed-height header row with the reports nav; its three items must never
  // wrap into a second line that would sit under the widgets.
  root: {
    width: 'auto',
    flexWrap: 'nowrap'
  },
  dateFilterItem: {
    cursor: 'pointer',
    background: 'transparent',
    font: 'inherit',
    margin: 0,
    '&:focus-visible': {
      outline: '2px solid #3C52EF',
      outlineOffset: 2
    },
    border: '1px solid #CCD4E4',
    padding: '3px 10px',
    '&:first-child': {
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
      borderRight: 'none'
    },
    '&:last-child': {
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      borderLeft: 'none'
    }
  },
  selectedItem: {
    background: '#CCD4E4'
  },
  itemText: {
    color: '#727B8C',
    fontFamily: 'Dazzed',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '24px'
  },
  selectedItemText: {
    color: '#3C52EF'
  }
}))

const DateFilter = ({ pastXDays, onChange }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const dateFilterItems = [
    {
      value: 7,
      text: t('pages.copilotControl.mainPage.dateFilter.last7Days')
    },
    {
      value: 30,
      text: t('pages.copilotControl.mainPage.dateFilter.last30Days')
    },
    {
      value: null,
      text: t('pages.copilotControl.mainPage.dateFilter.all')
    }
  ]

  return (
    <Grid container className={classes.root}>
      {dateFilterItems.map((item, index) => (
        <Grid
          item
          component="button"
          type="button"
          aria-pressed={item.value === pastXDays}
          key={index}
          className={[classes.dateFilterItem, item.value === pastXDays ? classes.selectedItem : ''].join(' ')}
          onClick={() => onChange(item.value)}
        >
          <span className={[classes.itemText, item.value === pastXDays ? classes.selectedItemText : ''].join(' ')}>
            {item.text}
          </span>
        </Grid>
      ))}
    </Grid>
  )
}

export default DateFilter
